"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _context = require("../context");
var _theming = require("../theming.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ThemeProvider = function ThemeProvider(_ref) {
  var name = _ref.name,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_context.ThemeContext.Provider, {
    value: {
      name: name
    }
  }, children);
};
ThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].oneOf(Object.values(_theming.Theme)),
  children: _propTypes["default"].node
} : {};
var _default = exports["default"] = ThemeProvider;